import { Link as RouterLink } from 'react-router-dom'

type Props = {
  url?: string
} & Omit<React.HTMLProps<HTMLAnchorElement>, 'ref'>

function Link(props: Props) {
  const { url = '', ...rest } = props

  const firstCharacter = url.substr(0, 1)

  switch (true) {
    case firstCharacter === '/' || firstCharacter === '?':
      return <RouterLink to={url} {...rest} />
    case url.length !== 0 && url !== '#': {
      const additionalAttrs = {
        ...rest,
        rel: '',
        target: rest.target || '_blank',
      }

      if (additionalAttrs.target === '_blank') {
        additionalAttrs.rel = 'noopener noreferrer'
      }

      return <a {...additionalAttrs} href={url} />
    }
    default:
      return <span {...rest} />
  }
}

export default Link
